import { TestIdDomain } from 'constants/testIds';

const TasksTestIdsScope = {
  TASK_ASSIGNMENT_FORM: 'task-assignment-form',
  TASK_TABLE_ROW: 'task-table-row',
  UNASSIGNED_FORM_PROMPT: 'unassigned-form-prompt',
};

export const TasksTestIds = {
  // TaskAssignmentForm
  TASK_ASSIGNMENT_FORM_DESCRIPTION_INPUT: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.description-input`,
  TASK_ASSIGNMENT_FORM_PREVIEW_BUTTON: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.preview-button`,
  TASK_ASSIGNMENT_FORM_SUBMIT_BUTTON: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.submit-button`,
  TASK_ASSIGNMENT_FORM_SUBMIT_ERROR: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.submit-error`,

  // TaskItem
  TASK_TABLE_ROW_NAME_CELL: `${TasksTestIdsScope.TASK_TABLE_ROW}.name-cell`,
  TASK_TABLE_ROW_ASSIGNMENT_CELL: `${TasksTestIdsScope.TASK_TABLE_ROW}.assignment-cell`,
  TASK_TABLE_ROW_CANCELATION_REASON_CELL: `${TasksTestIdsScope.TASK_TABLE_ROW}.cancelation-reason-cell`,
  TASK_TABLE_ROW_HISTORY_CELL: `${TasksTestIdsScope.TASK_TABLE_ROW}.history-cell`,
  TASK_TABLE_ROW_SLA_INFO_BUTTON: `${TasksTestIdsScope.TASK_TABLE_ROW}.sla-info-button`,
  TASK_TABLE_ROW_HISTORY_BUTTON: `${TasksTestIdsScope.TASK_TABLE_ROW}.history-button`,
  TASK_TABLE_ROW_LAST_MODIFIED_CELL: `${TasksTestIdsScope.TASK_TABLE_ROW}.last-modified-cell`,
  TASK_TABLE_ROW_SLA_GROUP_CELL: `${TasksTestIdsScope.TASK_TABLE_ROW}.sla-group-cell`,
  TASK_TABLE_ROW_TASK_TYPE_CELL: `${TasksTestIdsScope.TASK_TABLE_ROW}.task-type-cell`,

  // Tasks
  ASSIGN_TASK_BUTTON: `${TestIdDomain.TASKS}.assign-task-button`,
  FORM_VIEWER_DIALOG: `${TestIdDomain.TASKS}.form-viewer-dialog`,

  // Unassigned form close prompt
  UNASSIGNED_FORM_PROMPT_ASSIGN_BUTTON: `${TasksTestIdsScope.UNASSIGNED_FORM_PROMPT}.assign-button`,
  UNASSIGNED_FORM_PROMPT_DISCARD_BUTTON: `${TasksTestIdsScope.UNASSIGNED_FORM_PROMPT}.discard-button`,

  // TasksPage
  TABS: `${TestIdDomain.TASKS}.tabs`,
  TABLE: `${TestIdDomain.TASKS}.table`,

  // Dynamic
  getTaskHistoryRowId: taskId => `task-history-table.row-${taskId}`,

  // TaskAssignmentForm (inline)
  TASK_ASSIGNMENT_FORM_STATE_SELECT: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.state-select`,
  TASK_ASSIGNMENT_FORM_FORMID_SELECT: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.formId-select`,
  TASK_ASSIGNMENT_FORM_TASK_CATEGORY_INPUT: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.task-category`,
  TASK_ASSIGNMENT_FORM_TASK_CATEGORY_OPTION: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.task-category-option`,
  TASK_ASSIGNMENT_FORM_TASK_TYPE_INPUT: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.task-type`,
  TASK_ASSIGNMENT_FORM_TASK_TYPE_OPTION: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.task-type-option`,
  TASK_ASSIGNMENT_FORM_ENTITY_INPUT: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.entity`,
  TASK_ASSIGNMENT_FORM_ENTITY_OPTION: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.entity-option`,
  TASK_ASSIGNMENT_FORM_FORM_TYPE_INPUT: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.form-type`,
  TASK_ASSIGNMENT_FORM_FORM_TYPE_OPTION: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.form-type-option`,
  TASK_ASSIGNMENT_FORM_TASKASSIGNMENTTYPE_INPUT: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.taskAssignmentType`,
  TASK_ASSIGNMENT_FORM_TASKASSIGNMENTTYPE_OPTION: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.taskAssignmentType-option`,
  TASK_ASSIGNMENT_FORM_BORROWER_INPUT: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.borrower`,
  TASK_ASSIGNMENT_FORM_BORROWER_OPTION: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.borrower-option`,
  TASK_ASSIGNMENT_FORM_SLAGROUP_INPUT: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.slaGroup`,
  TASK_ASSIGNMENT_FORM_SLAGROUP_OPTION: `${TasksTestIdsScope.TASK_ASSIGNMENT_FORM}.slaGroup-option`,
};
